<template>
    <div v-if="contrato">
        <form class="form-horizontal" >
            <div class="form-group">
                <div class="col-sm-12">
                    <label for="nome" class="control-label">NOME DO CLIENTE</label>
                    <input id="nome" disabled type="text" v-model="contrato.cliente.nome" class="form-control" >
                </div>
            </div>

            <list-hotspot @reload="reload()" :id="contrato._id" :hotspot="contrato.hotspot"/>

            <a class="btn btn-success" v-if="user.level <= 1" @click="novaSenha()">
                <i class="fa fa-plus" aria-hidden="true"></i> NOVA SENHA
            </a><br/><br/>
        </form>
    </div>
</template>
<script>
import ListHotspot from "../../../components/contratos/ListHotspot.vue";
import contratoMixin from "../../mixins/contrato";
import { Contratos } from "../../../class/contratos";

export default {
    components: {
        ListHotspot
    },
    mixins: [contratoMixin],
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    },
    methods: {
        reload() {
            this.loadContrato();
        },
        novaSenha() {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "Hotspot",
                    confirmButtonText: "Cadastrar",
                    text: "Posso cadastrar a senha?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Contratos.addSenhaHotspot(this.contrato._id)
                                .then(() => {
                                    this.loadContrato();
                                    resolve();
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
